import { CircularProgress, Paper } from '@material-ui/core'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import AutoSizer from 'react-virtualized-auto-sizer'
import {
  HorizontalGridLines,
  LineSeries,
  VerticalBarSeries,
  VerticalGridLines,
  XAxis,
  XYPlot,
  YAxis
} from 'react-vis'
import Context from '../../../context'
import useStyles from './styles'

function VerticalBar() {
  const classes = useStyles()
  const { graphData, rangeDate, futureGraphData, isLoading } = useContext(Context)
  const [showBar, setShowBar] = useState(false)

  useEffect(() => {
    const start = moment(rangeDate[0])
    const end = moment(rangeDate[1])

    if (end.diff(start, 'days') < 7) {
      setShowBar(true)
    } else {
      setShowBar(false)
    }
  }, [rangeDate])

  return (
    <Paper elevation={0} className={classes.verticalBarArea}>
      {isLoading ? (
        <div className={classes.circularArea}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <h4>VALIDAÇÕES</h4>
          {showBar ? (
            <AutoSizer>
              {({ width }) => (
                <XYPlot margin={{ bottom: 70 }} width={width} height={400} xType="ordinal">
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis tickLabelAngle={-45} />
                  <YAxis />

                  <VerticalBarSeries data={graphData} />
                  <VerticalBarSeries data={futureGraphData} color="orange" />
                </XYPlot>
              )}
            </AutoSizer>
          ) : (
            <AutoSizer>
              {({ width }) => (
                <XYPlot margin={{ bottom: 70 }} width={width} height={400} xType="ordinal">
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis tickLabelAngle={-45} />
                  <YAxis />

                  <LineSeries data={graphData} />
                  <LineSeries data={futureGraphData} color="orange" />
                </XYPlot>
              )}
            </AutoSizer>
          )}
        </>
      )}
    </Paper>
  )
}

export default VerticalBar
